import { render, staticRenderFns } from "./InvitationQRcode.vue?vue&type=template&id=1b975bd3&scoped=true&lang=pug&"
import script from "./InvitationQRcode.vue?vue&type=script&lang=ts&"
export * from "./InvitationQRcode.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationQRcode.vue?vue&type=style&index=0&id=1b975bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b975bd3",
  null
  
)

export default component.exports